import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { routes } from 'routes/routes';

export const useNavigateToChat = () => {
  const navigate = useNavigate();

  return useCallback(async () => {
    await navigate(routes.chat.index);
  }, [navigate]);
};
